import React, { createContext, useState } from "react";

interface UnenrollmentActionContextType {  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;  
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  element: any;
  setElement: (element: any) => void;  
}

export const UnenrollmentActionContext = createContext<UnenrollmentActionContextType>({  
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  showModal: false,
  setShowModal: () => {},
  element: null,
  setElement: () => {},  
});

interface UnenrollmentActionProviderProps {
  children: React.ReactNode;
}

export const UnenrollmentActionProvider: React.FC<UnenrollmentActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [element, setElement] = useState<any>(null);  

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    showModal,
    setShowModal,
    element,
    setElement,    
  };
  return (
    <UnenrollmentActionContext.Provider value={value}>
      {children}
    </UnenrollmentActionContext.Provider>
  );
};
